import {BoldIcon} from '@primer/octicons-react'
import {ActionBar} from '@primer/react'

import styles from './Toolbar.module.css'
import {ToolbarButton} from './ToolbarButton'

export const Toolbar = () => {
  return (
    <ActionBar aria-label="Formatting tools" className={styles.actionBar}>
      <ToolbarButton onClick={() => {}} icon={BoldIcon} aria-label="Bold" />
      {/* <ToolbarButton onClick={() => {}} icon={ItalicIcon} aria-label="Italic" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={CodeIcon} aria-label="Code" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={QuoteIcon} aria-label="Quote" /> */}
      {/* <ActionBar.Divider /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ListUnorderedIcon} aria-label="Unordered list" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ListOrderedIcon} aria-label="Numbered list" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={TasklistIcon} aria-label="Task list" /> */}
      {/* <ActionBar.Divider /> */}
      {/* <ToolbarButton onClick={() => {}} icon={PaperclipIcon} aria-label="Attachment" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={ReplyIcon} aria-label="Saved replies" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={DiffIgnoredIcon} aria-label="Slash commands" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={AlertIcon} aria-label="Alert" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={CodeSquareIcon} aria-label="Code block" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={TableIcon} aria-label="Table" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={MultiSelectIcon} aria-label="Details" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={SquareIcon} aria-label="Footnote" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={HeadingIcon} aria-label="Heading" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={HorizontalRuleIcon} aria-label="Horizontal Rule" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={NumberIcon} aria-label="Math block" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={CrossReferenceIcon} aria-label="Reference" /> */}
      {/* <ToolbarButton onClick={() => {}} icon={StrikethroughIcon} aria-label="Strikethrough" /> */}
    </ActionBar>
  )
}
Toolbar.displayName = 'HybridMarkdownEditor.Toolbar'
